var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuretyBonds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    width: 600,
    height: 600,
    role: "img",
    "aria-label": "Fideiussioni e Cauzioni",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 300,
    r: 284
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186 132h178a20 20 0 0 1 20 20v266a20 20 0 0 1-20 20H186a20 20 0 0 1-20-20V152a20 20 0 0 1 20-20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212 196h136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212 244h136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212 292h96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212 340h72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372 452l-26 74 46-22 34 30 12-78"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396,
    cy: 404,
    r: 72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396,
    cy: 404,
    r: 40
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuretyBonds);
export default __webpack_public_path__ + "static/media/surety-bonds.bb808db4a9bc3e11e13b3621724ea156.svg";
export { ForwardRef as ReactComponent };